import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'security_self_audits'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'REMS' },
  USER: { label: 'Usuario' },
  REGION: { column: 'regions.name', label: 'Estado' },
  MUNICIPALITY: { column: 'municipalities.name', label: 'Municipio' },
  SECTOR: { column: 'sectors.name', label: 'Región' },
  CENTER: false,
  TENANT: false,
  STATUS: false,
})

export default {
  key: DATASET_KEY,
  label: 'Proced. Op. - Autoevaluaciones de Seguridad',
  timeColumn: 'security_self_audit_answers.created_at',
  permission: { action: 'read', subject: 'SecuritySelfAudit' },

  tables: {
    security_self_audit_answers: ["id", "uuid", "name", "data", "template_snapshot", "template_sources", "id_template", "id_security_self_audit", "created_at", "updated_at"],
    security_self_audits: ["id", "reference_number", "id_unit", "created_at", "updated_at", "id_user"],
    security_self_audit_templates: ["id", "uuid", "name", "data", "id_tenant", "id_user", "created_at", "updated_at"],
    security_self_audits_status: ["id", "id_security_self_audit", "id_status", "id_user", "created_at", "updated_at"],
    security_self_audits_status_catalog: ["id", "name", "created_at", "updated_at"],
    users: ["id", "id_unit", "id_maintenance_company", "image", "check_alarms", "frame_color", "id_profile", "user", "email", "password", "name", "first_name", "second_name", "config", "plate_number", "created", "updated", "active", "vpn_access", "allow_virtual_button_alarm", "allow_visual_notifications", "allowed_units_live_video_flows", "phone_number", "alarm_history_per_hours", "alarm_history_per_days", "alarm_history_by_records", "last_login", "video_wall", "active_sesion_video_wall", "id_country", "auth_two_factor_code", "auth_two_factor_time", "auth_two_factor_type", "verify_email_code", "verify_sms_code", "verify_sms", "verify_email", "online", "enabled_chat", "enabled_helpdesk"],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "created_at", "updated_at"],
    sectors: ["id", "id_center", "name", "alcaldia", "provider", "created", "updated"],
    centers: ["id", "tenant_id", "name", "description", "updated", "created", "active"],
    regions: ["id", "name", "code", "country_id", "acronym", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'units.description',
  },

  csvConfig: {
    withTables: 'security_self_audit_answers',
    columns: 'security_self_audit_answers.uuid,security_self_audit_answers.name,security_self_audit_answers.data,security_self_audit_answers.template_sources,security_self_audit_answers.created_at,security_self_audit_answers.updated_at,security_self_audits.reference_number,security_self_audits.created_at,security_self_audits.updated_at,security_self_audit_templates.uuid,security_self_audit_templates.name,security_self_audit_templates.created_at,security_self_audit_templates.updated_at,security_self_audits_status.created_at,security_self_audits_status.updated_at,security_self_audits_status_catalog.name,security_self_audits_status_catalog.created_at,security_self_audits_status_catalog.updated_at,units.description,units.active,municipalities.name,sectors.name,regions.name',
    exceptColumns: 'security_self_audit_answers.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'security_self_audit_answers.data', label: 'Autoeval. - Seguridad', processForm: true },
    { key: 'users.name', label: 'Nombre usuario' },
    { key: 'users.id_profile', label: 'Perfil' },
    { key: 'units.description', label: 'REMS' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'security_self_audits.created_at', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
    { key: 'security_self_audits.updated_at', label: 'Fecha de actualización', defaultParams: { freq: '1mo' } },
    { key: 'security_self_audits_status_catalog.name', label: 'Estatus' },
  ],

  filters: [
    ...commonFilters,
    {
      key: 'question',
      label: 'Preguntas de la autoevaluación',
      forField: 'Preguntas de la autoevaluación',
      filterType: 'process-form',
      optionsConfig: {
        type: 'json-keys',
        dataset: 'security_self_audits',
        column: 'security_self_audit_answers.data',
        limit: -1,
      },
    },
    embedFilter(DATASET_KEY, 'security_self_audits_status_catalog.name', 'Estatus', 'status'),
    {
      key: 'audit_created_at',
      label: 'Fecha de creación',
      filterType: 'where-date',
      whereColumn: 'security_self_audits.created_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'audit_updated_at',
      label: 'Fecha de actualización',
      filterType: 'where-date',
      whereColumn: 'security_self_audits.updated_at',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'security_self_audit_answers.created_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
